// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCk6LAmJ6b3PFURJDwskLCxMMHjxTV8Ioo",
  authDomain: "fast-grocer-01.firebaseapp.com",
  projectId: "fast-grocer-01",
  storageBucket: "fast-grocer-01.appspot.com",
  messagingSenderId: "491886969293",
  appId: "1:491886969293:web:700646cd716f3d1aaec484"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
